import { twMerge } from '@panwds/tailwindcss';
export const logoV3Classes = {
    generic: {
        boxSizing: 'tw-box-border'
    },
    a: {
        display: 'twds-flex',
        dimension: 'twds-h-[4.125rem]',
        layout: 'twds-items-center',
        spacing: 'twds-mx-2'
    },
    collapsed: {
        border: 'tw-border-0',
        spacing: 'twds-ml-1 twds-p-[5px]'
    },
    open: {
        boxSizing: 'tw-box-border',
        border: 'tw-border-0',
        spacing: 'twds-ml-2'
    }
};
export function getLogoATagClasses(className) {
    return twMerge(logoV3Classes.a.display, logoV3Classes.a.dimension, logoV3Classes.a.layout, logoV3Classes.a.spacing, className);
}
export function getLogoCollapsedClasses(className) {
    return twMerge(logoV3Classes.collapsed.border, logoV3Classes.collapsed.spacing, logoV3Classes.generic.boxSizing, className);
}
export function getLogoOpenClasses(className) {
    return twMerge(logoV3Classes.open.border, logoV3Classes.generic.boxSizing, logoV3Classes.open.spacing, className);
}
//# sourceMappingURL=logoV3.logic.js.map